import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Icon } from '@shopflo/ui'
import { ArrowsMerge } from '@phosphor-icons/react'
import { useDiscountForm } from '../../hooks/useDiscountForm'
import { DiscountStackabilityFormV2Type, DiscountStackMode } from 'src/lib/types/discountsV2'
import CustomDiscountSelector from './CustomDiscountSelector'

import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountCombinationModeV2 = () => {
  const {
    state: { prerequisite },
    actions: { setFormState }
  } = useDiscountForm()
  const { canAccess } = useUser()
  const { t } = useLocale()

  const { stackability } = prerequisite
  const hasGroupPermission = canAccess(permissionType.GROUP_DISCOUNTS, 0)

  const handleTypeChange = (value: DiscountStackMode) => {
    let newStackability: DiscountStackabilityFormV2Type

    switch (value) {
      case DiscountStackMode.ALL:
        newStackability = { stackMode: DiscountStackMode.ALL }
        break
      case DiscountStackMode.NONE:
        newStackability = { stackMode: DiscountStackMode.NONE }
        break
      case DiscountStackMode.CUSTOM:
        newStackability = {
          stackMode: DiscountStackMode.CUSTOM,
          customStackableDiscountIds: []
        }
        break
      default:
        newStackability = { stackMode: DiscountStackMode.ALL }
    }

    setFormState({
      prerequisite: {
        ...prerequisite,
        stackability: newStackability
      }
    })
  }

  const eligibilityOptions = [
    { value: DiscountStackMode.ALL, label: t('discounts_v2.all') },
    { value: DiscountStackMode.NONE, label: t('discounts_v2.none_label') },
    ...(hasGroupPermission ? [{ value: DiscountStackMode.CUSTOM, label: t('discounts_v2.custom') }] : [])
  ]

  return (
    <div>
      <div className='flex flex-col w-full px-3 hover:bg-zinc-500/5 rounded-xl'>
        <div className='flex flex-col py-3'>
          <Select value={stackability.stackMode} onValueChange={handleTypeChange}>
            <SelectTrigger
              id='discount-combination-trigger'
              className='w-[260px] border-none p-0 h-auto shadow-none focus:ring-0 group hover:bg-transparent flex items-center justify-start gap-1.5 cursor-pointer'
            >
              <Icon IconComponent={ArrowsMerge} size='sm' className='text-zinc-400' />
              <span className='text-text-sm-regular text-zinc-500'>{t('discounts_v2.combine_with')} </span>
              <span className='text-text-sm-semibold text-zinc-600 transition-colors group-hover:text-zinc-700 !lowercase'>
                <SelectValue />
              </span>
            </SelectTrigger>
            <SelectContent align='start' className='w-[260px]'>
              {eligibilityOptions.map(option => (
                <SelectItem
                  id={`combination-mode-option-${option.value.toLowerCase()}`}
                  key={option.value}
                  value={option.value}
                  className='max-w-[300px]'
                >
                  <span>{option.label}</span>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className='px-3'>{stackability.stackMode === DiscountStackMode.CUSTOM && <CustomDiscountSelector />}</div>
    </div>
  )
}

export default DiscountCombinationModeV2
